<template>
    <card :noFooterLine="true" class="news-card" :class="{ 'skeleton' : isSkeleton, 'main' : (type == 'main'), 'sub' : (type == 'sub'), 'select' : (type == 'select') }" @click.native="cardClick">

        <div slot="image" v-if="news" class="news-card-image" :style="`background-image:url(${news.image})`"></div>

        <div slot="header" v-if="news">
            <h6 class="card-category" >{{ type }} News</h6>
            <h4 class="card-title">{{ news.title }}</h4>
            <p class="card-description">{{ news.author.name }}</p>
        </div>

        <div class="news-card-body" v-if="news">
            <p class="card-text">{{ news.small_description }}</p>
        </div>

        <skeleton-loading v-if="isSkeleton && type == 'main'">
            <row :gutter="{top: '10px', bottom: '10px'}">
                <column :span="1" :gutter="10" class="col-12">
                    <square-skeleton :boxProperties="{ bottom: '0px', height: '200px' }"></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '10px', height: '40px', width: '100%' }" backColor="#bdc3c7"></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '5px', height: '10px', width: '100%' }" :count="2"></square-skeleton>
                </column>
            </row>
        </skeleton-loading>

        <skeleton-loading v-if="isSkeleton && type == 'sub'">
            <row :gutter="{top: '10px', bottom: '10px'}">
                <column :span="1" :gutter="10" class="col-3">
                    <square-skeleton :boxProperties="{ bottom: '0px', height: '200px' }"></square-skeleton>
                </column>
                <column :span="1" :gutter="10" class="col-9">
                    <square-skeleton :boxProperties="{ bottom: '10px', height: '10px', width: '15%' }" ></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '15px', height: '40px', width: '80%' }" backColor="#bdc3c7"></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '20px', height: '15px', width: '25%' }" ></square-skeleton>
                    <square-skeleton :boxProperties="{ bottom: '5px', height: '10px', width: '90%' }" :count="4"></square-skeleton>
                    <square-skeleton :boxProperties="{ top: '15px', height: '15px', width: '20%' }"></square-skeleton>
                </column>
            </row>
        </skeleton-loading>

        <div slot="footer" v-if="news">
            <p>{{ date }}</p>
        </div>
    </card>
</template>

<script>

import { Card } from 'src/components';
import {Tooltip} from 'element-ui';

export default {
    name: 'NewsCard',
    components: {
        Card,
        [Tooltip.name]: Tooltip,
    },
    props: {
        type: String,
        news: Object
    },
    computed: {
        date: function(){
            if(this.news){
                let date = new Date(this.news.date)
                return date.toLocaleString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
            }
            else{
                return ''
            }
        },
        isSkeleton: function(){
            return (this.news == undefined || this.news == null) ? true : false
        }
    },
    methods: {
        cardClick(){
            this.$emit('card-click', this.news)
        }
    }
}
</script>

<style lang="scss">

.vue-skeleton-loading .skeleton-bac-animation{
    z-index: 1!important;
}

@keyframes backpos{ 0%{ background-position-x: -100px; } to { background-position-x: 100%; } }

.news-card{

    cursor: url('/img/icons/delete.png'), auto;

    &.skeleton{
        cursor: pointer;

        .card-image,
        .card-header,
        .card-footer,
        .news-card-body{
            display: none;
        }

        .card-body{
            width: 100%;
        }
    }

    &.main{
        .card-image{
            width: 100%;
            float: left;
            height: 400px;
            z-index: 0;
            position: relative;

            .news-card-image{
                height: 400px;
                background-size: cover;
            }
        }

        .card-header{
            margin-top: -80px;
            height: 80px;
            overflow: hidden;
            z-index: 1;
            position: relative;
            color: #fff;
            background: rgba(0, 0, 0, 0.30);
        }

        .card-description,
        .news-card-body,
        .card-footer{
            display: none;
        }

        .card-header,
        .card-body,
        .card-footer{
            width: 100%;
            float: right;
        }
    }

    &.select{
        cursor: url('/img/icons/check.png'), auto;

        .card-image{
            height: 100px;

            .news-card-image{
                height: 100px;
                background-size: cover;
            }
        }

        .card-header{
            padding: 5px 5px 0;
        }

        .card-header .card-title{
            font-size: 1rem;
        }

        .category, 
        .card-category,
        .card-footer,
        .card-body{
            display: none;
        }
    }   

    .card-image{
        width: 24%;
        float: left;
        margin-right: 1%;
    }

    .card-header,
    .card-body,
    .card-footer{
        width: 75%;
        float: right;
    }

    .card-footer .status-btns .btn{
        margin-right: 3px;
    }

    .card-header .card-title{
        margin-bottom: 0.5rem;
        margin-top: 5px;
    }

    .category, .card-category{
        margin-bottom: 0.2em;
    }

    .card-body{
        padding: 5px 15px 15px 15px;
    }

    .description, 
    .card-description, 
    .footer-big p, 
    .footer .stats{
        color: #353a3e;
    }

    .news-card-image{
        position: relative;
        text-align: center;
        box-shadow: inset -1px -5px 5px -3px rgba(0, 0, 0, 0.16);
        height: 250px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;

        .action-btn{
            box-shadow: 0px 2px 3px rgba(0,0,0,0.16);
            position: absolute;
            right: -20px;
            bottom: -30px;
        }

        .card-img-top{
            height: 250px;
            width: auto;
            margin: 0 auto;
            text-align: center;
        }
    }

} 









</style>
